import { NumberInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventOptionalAttendeePointsInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { optionalPointsPerEvent } = values;

    const updateValue = (value: number | string) => {
        updateValues({
            ...values,
            optionalPointsPerEvent: Number(value) || 0,
        });
    };

    return (
        <NumberInput
            id="event-optional-points-input"
            label={intl.formatMessage(sharedMessages.optionalPointsPerEvent)}
            placeholder={intl.formatMessage(sharedMessages.pointsPerEventPlaceholder)}
            min={0}
            max={128}
            onChange={updateValue}
            value={optionalPointsPerEvent ?? undefined}
            radius="md"
            size="md"
        />
    );
};

export default EventOptionalAttendeePointsInput;
